import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import AdminSideBar from "../../Components/Admin/AdminSideBar";
import AdminHeader from "../../Components/Admin/AdminHeader";
import GlobalContext from "../../Hooks/globalContext";
import "../../Styles/pagination.css";
import useState from "../../Hooks/useState";
import UserPage from "../../Components/Admin/Pages/UserPage";
import LogPage from "../../Components/Admin/Pages/LogPage";
import BalancePage from "../../Components/Admin/Pages/BalancePage";
import ConfigPage from "../../Components/Admin/Pages/ConfigPage";
import ExchangePage from "../../Components/Admin/Pages/ExchangePage";
import NoticePage from "../../Components/Admin/Pages/NoticePage";
import WritePage from "../../Components/Admin/Pages/WritePage";

const AdminContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #0f172a;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
`;

const MainArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ContentArea = styled.div`
  flex: 1;
  overflow: auto;
`;

const Container = ({ history, location }) => {
  const { isLogin, user, getUser, logout, language } = useContext(GlobalContext);
  const page = useState("userList");
  const focus = useState(null);

  const preload = async () => {
    const _user = await getUser();
    if (_user === "expired") {
      return;
    }
    if (_user.is_admin === 0) {
      history.push("/");
    }
  };

  useEffect(() => {
    preload();
  }, []);

  return (
    <AdminContainer>
      {user.state && (
        <>
          <Helmet>
            <title>Admin | Wallet</title>
          </Helmet>
          <AdminSideBar page={page} onLogout={logout} />
          <MainArea>
            <ContentArea>
              <AdminHeader page={page.state} />

              {page.state === "shopList" && (
                <LogPage
                  adminPage={page}
                  tableName="shop"
                  columnList="shopList"
                  columnName="shopList"
                  searchList={[
                    ["id", "번호"],
                    ["email", "관리자 이메일"],
                  ]}
                />
              )}
              {page.state === "noticeList" && (
                <NoticePage adminPage={page} focus={focus} hostPath={"/admin/notice/list"} />
              )}
              {page.state === "noticeWrite" && (
                <WritePage adminPage={page} hostPath={"/admin/notice/crud"} />
              )}
              {page.state === "noticeUpdate" && (
                <WritePage adminPage={page} type="update" focus={focus} hostPath={"/admin/notice/crud"} />
              )}
              {page.state === "lockupList" && (
                <LogPage
                  adminPage={page}
                  tableName="lock_up"
                  columnName="lockupList"
                  columnList="lockList"
                  searchList={[
                    ["t.id", "번호"],
                    ["t.user_id", "유저 번호"],
                    ["t.user_email", "유저 이메일"],
                    ["t.token_type", "토큰 타입"],
                  ]}
                />
              )}
              {page.state === "userList" && (
                <UserPage adminPage={page} hostPath={"/admin/users"} />
              )}
              {page.state === "stakingList" && (
                <LogPage
                  adminPage={page}
                  tableName="staking"
                  columnName="stakingList"
                  columnList="stakingList"
                  searchList={[
                    ["t.id", "번호"],
                    ["t.user_id", "유저 번호"],
                  ]}
                />
              )}
              {page.state === "swapList" && (
                <LogPage
                  adminPage={page}
                  tableName="app_swap_log"
                  columnName="swapList"
                  columnList="swapList"
                  searchList={[["t.id", "번호"]]}
                />
              )}
              {page.state === "balance" && (
                <BalancePage adminPage={page} hostPath={"/admin/log/point"} />
              )}
              {page.state === "sendLog" && (
                <LogPage
                  adminPage={page}
                  tableName="app_send_log"
                  columnName="sendLog"
                  columnList="app_send_log"
                  searchList={[
                    ["id", "번호"],
                    ["t.send_email", "보내는 유저 메일"],
                    ["t.receive_email", "받는 유저 메일"],
                    ["t.send_address", "보내는 지갑주소"],
                    ["t.receive_address", "받는 지갑주소"],
                    ["t.type", "전송 토큰 심볼"],
                  ]}
                />
              )}
              {page.state === "shopExchange" && (
                <LogPage
                  adminPage={page}
                  tableName="app_send_log"
                  columnName="shopExchange"
                  columnList="app_send_log"
                  condition=" shop_id is not null "
                  searchList={[
                    ["id", "번호"],
                    ["t.send_email", "보내는 유저 메일"],
                    ["t.receive_email", "받는 유저 메일"],
                    ["t.send_address", "보내는 지갑주소"],
                    ["t.receive_address", "받는 지갑주소"],
                    ["t.type", "전송 토큰 심볼"],
                  ]}
                />
              )}
              {page.state === "withdraw" && (
                <ExchangePage
                  adminPage={page}
                  tableName="app_withdraw"
                  columnName="withdraw"
                  columnList="withdraw"
                  searchList={[
                    ["t.id", "번호"],
                    ["t.user_id", "유저 번호"],
                  ]}
                />
              )}
              {page.state === "config" && <ConfigPage adminPage={page} />}
            </ContentArea>
          </MainArea>
        </>
      )}
    </AdminContainer>
  );
};

export default Container;
